<script setup>
import { WdsIllustration } from '@wds/components';

const props = defineProps({
  hasResults: {
    type: Boolean,
    required: true,
  },
  propertyTypeObj: {
    type: Object,
    required: true,
  },
  locationName: {
    type: String,
    required: true,
  },
  locationNameParent: {
    type: String,
    required: false,
    default: '',
  },
  hasOtherLocations: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { t } = useI18n();

// ### COMPUTED
const getNoResultsTitle = computed(() => {
  return t('t_NORESULTSINTHISLOCATIONTITLE', {
    PROPERTYTYPES: t(props.propertyTypeObj.transcode),
    LOCATIONNAME: props.locationName,
  });
});

const getNoResultsText = computed(() => {
  return t('t_NORESULTSINTHISLOCATIONTEXT', {
    PROPERTYTYPES: t(props.propertyTypeObj.transcode),
    LOCATIONNAME: props.locationName,
  });
});

const getNoResultsOtherLocationsText = computed(() => {
  return t('t_NORESULTSINTHISLOCATIONLINK', {
    PROPERTYTYPES: t(props.propertyTypeObj.transcode),
    PARENTLOCATIONNAME: props.locationNameParent,
  });
});
</script>

<template>
  <section
    v-if="!props.hasResults"
    class="no-results"
  >
    <WdsIllustration
      asset="search"
      folder="lg"
      width="80"
      height="80"
      :alt-text="getNoResultsTitle"
      :title="getNoResultsTitle"
    />
    <span class="no-results-text">
      <p class="title">{{ getNoResultsTitle }}</p>
      <p class="text">{{ getNoResultsText }}</p>
      <span v-if="props?.hasOtherLocations && props?.locationNameParent">
        <a
          href="#otherlocations"
          target="_self"
          rel="noopener"
        >{{ getNoResultsOtherLocationsText }}</a>
      </span>
    </span>
  </section>
</template>

<style lang="scss" scoped>
.no-results {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: $wds-spacing-l;
  border: wds-rem(1px) solid $wds-color-ink-lighter;
  background: $wds-color-white;
  gap: $wds-spacing-s;
  padding: $wds-spacing-m $wds-spacing-s;

  .no-results-text {
    text-align: left;
    margin: $wds-spacing-s;

    .title {
      @include title-5-bld;

      font-size: $wds-font-size-title-5;
      line-height: $wds-line-height-title-3;
    }

    .text {
      @include body-2-reg;

      line-height: $wds-line-height-title-3;
    }

    a {
      color: $wds-color-ink-darker;
      text-decoration: underline;
      font-weight: $wds-font-weight-bold;
    }
  }
}
</style>
